import { render } from "./FooterWidgets.vue?vue&type=template&id=0b0f0da4&lang=html"
import script from "./FooterWidgets.vue?vue&type=script&lang=js"
export * from "./FooterWidgets.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__